import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Modal,
  TextField,
  Typography
} from '@mui/material'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import { createEffect, createStore } from 'effector'
import api from '../../Auth/api'
import { useStore } from 'effector-react'
import { $userSearch, searchUserFx } from '../../Api/userSearch'
import { useForm } from 'react-hook-form'
import debounce from 'lodash/debounce'
import { updateModal } from '../ErrorModal'
import { Stack } from '@mui/system'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 2,
  p: 2
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

export const $responsiblesTable = createStore(null)

export const getResponsiblesTableFx = createEffect(async () => {
  return api.get(`paid-service/task-type-list`)
})

$responsiblesTable.on(getResponsiblesTableFx, (state) => {
  return {
    ...state
  }
})

$responsiblesTable.on(getResponsiblesTableFx.done, (state, { result }) => {
  return {
    ...state,
    data: result.data.data
  }
})

$responsiblesTable.on(getResponsiblesTableFx.fail, (state, { error }) => {
  return {
    ...state
  }
})

export default function ResponsiblesTable() {
  const responsiblesTable = useStore($responsiblesTable)
  const usersTable = useStore($userSearch)
  const [open, setOpen] = React.useState(false)
  const [responsible, setResponsible] = React.useState()
  const [id, setId] = React.useState('')
  const [departmentName, setDepartmentName] = React.useState('')
  const [timeToComplete, setTimeToComplete] = React.useState('')

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()
  const [dependsOnDepartment, setDependsOnDepartment] = React.useState(false)
  const handleDependsOnDepartmentChange = () => {
    setDependsOnDepartment((value) => !value)
    setResponsible(undefined)
  }

  const handleTimeToCompleteChange = (event) => {
    setTimeToComplete(event.target.value)
  }
  const searchUser = React.useCallback(
    debounce((_, value) => {
      searchUserFx(value)
    }, 200),
    []
  )
  const onUpdateFormSubmit = () => {
    const time = `${String(timeToComplete).padStart(2, '0')}:00:00`
    updateTypeTaskFx({
      id,
      time,
      dependsOnDepartment,
      responsibleUserIds: responsible?.map((r) => r.id) || []
    })
  }
  const handleCloseModal = () => setOpen(false)
  const handleOpenModal = (row) => {
    setId(row?.id)
    setTimeToComplete(Number(row?.executionTime?.split(':')[0]))
    setDepartmentName(row?.name)
    setDependsOnDepartment(row?.dependsOnDepartment)
    setResponsible(row?.responsibleUsers)
    setOpen(true)
  }
  const updateTypeTaskFx = createEffect(async (data) => {
    api
      .post(`/paid-service/task-type-update`, data)
      .then(
        () => getResponsiblesTableFx(),
        (error) => updateModal(error.response.data.errors)
      )
      .then(() => handleCloseModal())
  })
  React.useEffect(() => {
    getResponsiblesTableFx()
  }, [])
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ border: '1px solid #e6e6e6', boxShadow: 0 }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Стадия
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Ответственные
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Рабочее время на выполнение
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {responsiblesTable?.data?.length > 0 &&
              responsiblesTable?.data?.map((row) => {
                return (
                  <StyledTableRow key={row.id}>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">
                      {row.dependsOnDepartment ? (
                        <Typography variant="caption">
                          Берутся из отдела
                        </Typography>
                      ) : (
                        <Stack direction="column">
                          {row.responsibleUsers.map((u) => (
                            <Typography variant="caption">{u.name}</Typography>
                          ))}
                        </Stack>
                      )}
                    </TableCell>
                    <TableCell align="center">{row.executionTime}</TableCell>
                    <TableCell align="center">
                      <Button onClick={() => handleOpenModal(row)}>
                        Редактировать
                      </Button>
                    </TableCell>
                  </StyledTableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={handleSubmit(onUpdateFormSubmit)}>
          <Box sx={style}>
            <Typography
              mb={3}
              id="modal-modal-title"
              variant="h6"
              fontWeight={600}
            >
              {departmentName}
            </Typography>
            <Box display="flex" alignItems="center" mb={2}></Box>
            {departmentName !== 'УПД' && (
              <Box display="flex" alignItems="center">
                <Typography
                  width={180}
                  mb={1}
                  variant="subtitle1"
                  fontWeight={600}
                >
                  Время на выполнение(часов):
                </Typography>
                <Box display="flex" gap={0.5} flexDirection="column">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    sx={{ width: 260 }}
                    value={timeToComplete}
                    onChange={handleTimeToCompleteChange}
                  />
                </Box>
              </Box>
            )}

            <Box display="flex" alignItems="center">
              <Typography
                width={170}
                mb={1}
                variant="subtitle1"
                fontWeight={600}
              >
                Брать ответственных из отдела:
              </Typography>
              <Checkbox
                checked={dependsOnDepartment}
                onChange={handleDependsOnDepartmentChange}
              />
            </Box>
            {!dependsOnDepartment && (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                mt={2}
              >
                <Typography
                  width={180}
                  mb={1}
                  variant="subtitle1"
                  fontWeight={600}
                >
                  Ответственные:
                </Typography>
                <Box width="260px">
                  <Autocomplete
                    id="tags-standard"
                    options={usersTable}
                    value={responsible}
                    multiple
                    onInputChange={searchUser}
                    onChange={(_, value) => setResponsible(value)}
                    getOptionLabel={(option) => option?.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField {...params} {...register('users')} />
                    )}
                  />
                  {errors.users && <span>Поле обязательно для заполнения</span>}
                </Box>
              </Box>
            )}
            <Box
              mt={3}
              width="100%"
              display="flex"
              gap={3}
              justifyContent="flex-end"
            >
              <Button variant="outlined" onClick={handleCloseModal}>
                Отмена
              </Button>
              <Button type="submit" variant="contained">
                Сохранить
              </Button>
            </Box>
          </Box>
        </form>
      </Modal>
    </>
  )
}
